export default function resetPersonalIdentityNumber(input) {
  input.type = 'text';
  input.readOnly = false;
  const placeholder = document.getElementById( input.id + '_placeholder' );
  placeholder.type = 'hidden';
  placeholder.value = '';
  placeholder.disabled = true;
}